import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ParamType, UpdateComponentProps } from '../../Routers/CrudRouter';
import { ArticleResponse, UpdateArticleRequest } from '../../../swagger/putujmoAdminService';
import { useGoBackFromUpdate } from '../../../utils/crudHooks';
import { getArticleAction, updateArticleAction } from '../../../features/articles/action';
import { tryCatchJsonByAction } from '../../../utils/fetchUtils';
import { LoadingSpinner } from '../../../components/LoadingSpinner/LoadingSpinner';
import { Dialog } from '../../../components/Dialog/Dialog';
import { CrudEnum } from '../../../settings/routes';
import { ArticleForm } from '../Forms/ArticleForm';

export const UpdateArticle = ({ publishDataChanged, additionalData }: UpdateComponentProps) => {
	const params: ParamType = useParams();
	const id = parseInt(params.id as string);

	const [loading, setLoading] = useState(true);
	const [data, setData] = useState(new ArticleResponse());
	const goBackFromUpdate = useGoBackFromUpdate();

	const fetchDataCallback = useCallback(
		async () => {
			setLoading(true);
			const bindedAction = getArticleAction.bind(null, id)
			var getResponse = await tryCatchJsonByAction(bindedAction);
			if (getResponse.success) {
				setData(getResponse.response || new ArticleResponse())
			}
			setLoading(false);
		},
		[id]
	)

	useEffect(
		() => {
			fetchDataCallback();
		},
		[fetchDataCallback]
	)

	const handleSave = useCallback(
		async (newValues: UpdateArticleRequest) => {
			setLoading(true);
			const model = new UpdateArticleRequest({
				...newValues,
				id
			})
			const bindedAction = updateArticleAction.bind(null, model);
			const response = await tryCatchJsonByAction(bindedAction);
			setLoading(false);

			if (response.success) {
				toast.success('Element je uspešno izmenjen.');
				publishDataChanged();
				goBackFromUpdate();
			} 
		},
		[publishDataChanged, goBackFromUpdate, id]
	);

	if (loading) {
		return <LoadingSpinner />
	}

	return (
		<Dialog
			title='Izmena elementa'
			onClose={goBackFromUpdate}
			size='xxxlarge'
			open
		>
			<ArticleForm
				values={data}
				onSubmit={handleSave}
				onCancel={goBackFromUpdate}
				crudEnum={CrudEnum.Update}
				articleType={additionalData.articleType}
			/>
		</Dialog>
	)
}
